module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/tap-icon-204f5556347223077fa924c4663fe343.svg";